import axios from 'axios';
import { BASE_URL } from '../ApiService/ApiConfig';

const obtenerConfig = () => {
    const token = localStorage.getItem('jwt').replaceAll('"', '');

    return {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            Authorization: 'Bearer ' + token
        }
    };
};

export const recuperaDatSiniestro = async (objPost) => {
    //console.log ('PARAMETROS....: ', objPost)
    try {
        const response = await axios.post(`${BASE_URL}/siniestros/datos`, objPost, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al consultar Siniestros`, error);
        throw new Error('Al consultar Siniestros');
    }
};

export const recuperaClienteSiniestro = async () => {
    const CODE_CONFIGCAB_CLIENTESINIESTRO = 'SIN-0000-0002';
    try {
        const response = await axios.get(
            `${BASE_URL}/configuracion/configuracion-det/configuracion-cab/codigo/${CODE_CONFIGCAB_CLIENTESINIESTRO}`,
            obtenerConfig()
        );
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al recuperar Clientes`, error);
        throw new Error('Al recuperar Clientes');
    }
};

export const recuperaConfDePadre = async (padreId) => {
    try {
        const response = await axios.get(`${BASE_URL}/configDet/padre/${padreId}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al recuperar Configuraciones por Padre`, error);
        throw new Error('Al recuperar Configuraciones por Padre');
    }
};

export const recuperaUbicacionSin = async (tipoUbicaion) => {
    //console.log ('DATOS PARA UBICACION', tipoUbicaion)
    try {
        const response = await axios.get(`${BASE_URL}/ubicacion/porTipo/${tipoUbicaion}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al recuperar Ubicacion de tipo`, error);
        throw new Error('Al recuperar Ubicacion de tipo');
    }
};

export const recuperaUbicacionPuesto = async (ubicacionId) => {
    //console.log('UBICACION PARA ENCONTRAR...: ', ubicacionId)
    try {
        const estado = 'Activo';
        const response = await axios.get(`${BASE_URL}/ubicacion/${ubicacionId}/estado/${estado}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al recuperar Ubicacion de Puesto`, error);
        throw new Error('Al recuperar Ubicacion de Puesto');
    }
};

export const recuperaConfigByCab = async (codigoCab) => {
    try {
        const response = await axios.get(`${BASE_URL}/configDet/codigoCab/${codigoCab}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al recuperar configuraciones por Cabecera`, error);
        throw new Error('Al recuperar configuraciones por Cabecera');
    }
};

export const creaSiniestro = async (objPost) => {
    //console.log('OBJETO CREA.:', objPost)
    try {
        const response = await axios.post(`${BASE_URL}/siniestros`, objPost, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al recuperar configuraciones por Cabecera`, error);
        throw new Error('Al recuperar configuraciones por Cabecera');
    }
};

export const modificaSiniestro = async (objPost) => {
    //console.log('KKKKK OBJETO MODIFICA.:', objPost);
    try {
        const response = await axios.put(`${BASE_URL}/siniestros`, objPost, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al modificar Datos del Siniestro`, error);
        throw new Error('Al modificar Datos del Siniestro');
    }
};

export const anularSiniestro = async (siniestroId) => {
    //console.log('ELEMENTO PARA ELIMINAAR: ', siniestroId);
    try {
        const response = await axios.get(`${BASE_URL}/siniestros/anular/${siniestroId}`, obtenerConfig());
        console.log(response.data);
    } catch (error) {
        console.error(`ERROR: Al Anular el Siniestro`, error);
        throw new Error('Error al Anular el Siniestro');
    }
};

export const creaFuenteSiniestro = async (objDatos) => {
    //console.log('ELEMENTO FUENTE PARA CREAR: ', objDatos);
    try {
        const response = await axios.post(`${BASE_URL}/siniestroFuente`, objDatos, obtenerConfig());
        //console.log(response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al crear Fuente de Siniestro`, error);
        throw new Error('Error Al crear Fuente de Siniestro');
    }
};

export const modificaFuenteSiniestro = async (objDatos) => {
    //console.log('ELEMENTO FUENTE PARA CREAR: ', objDatos);
    try {
        const response = await axios.put(`${BASE_URL}/siniestroFuente`, objDatos, obtenerConfig());
        //console.log(response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al crear Fuente de Siniestro`, error);
        throw new Error('Error Al crear Fuente de Siniestro');
    }
};

export const obtieneFuentesSiniestro = async (siniestroId) => {
    try {
        const response = await axios.get(`${BASE_URL}/siniestroFuente/siniestro/${siniestroId}`, obtenerConfig());
        //console.log(response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al crear Fuente de Siniestro`, error);
        throw new Error('Error Al crear Fuente de Siniestro');
    }
};

export const anulaFuenteSiniestro = async (fuenteId) => {
    try {
        const response = await axios.get(`${BASE_URL}/siniestroFuente/anular/${fuenteId}`, obtenerConfig());
        //console.log('RETURN ... ANULA ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al crear Fuente de Siniestro`, error);
        throw new Error('Error Al crear Fuente de Siniestro');
    }
};

export const crearDuenoSiniestro = async (objPost, codeConfigCab) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/siniestros/crearDueno/${codeConfigCab}`,
            objPost,
            obtenerConfig()
        );
        //console.log('RETURN ... crear ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al crear Dueno de Siniestro`, error);
        throw new Error('Error Al crear Dueno de Siniestro');
    }
};

export const modificarDuenoSiniestro = async (objPost, codeConfigCab) => {
    try {
        const response = await axios.put(
            `${BASE_URL}/siniestros/updateDueno/${codeConfigCab}`,
            objPost,
            obtenerConfig()
        );
        //console.log('RETURN ... crear ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al modificar Dueno de Siniestro`, error);
        throw new Error('Al modificar Dueno de Siniestro');
    }
};

export const eliminarDuenoSiniestro = async (configDetId) => {
    try {
        const response = await axios.delete(
            `${BASE_URL}/siniestros/eliminarDueno/${configDetId}`,
            obtenerConfig()
        );
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al eliminar Dueno de Siniestro`, error);
        throw new Error('Al eliminar Dueno de Siniestro');
    }
};

export const guardaDocumentoSin = async (siniestroId, objPost) => {
    try {
        const response = await axios.post(`${BASE_URL}/siniestros/documento/${siniestroId}`, objPost, obtenerConfig());
        //console.log('RETURN  DOCUMENTO... crear ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al grabar Documento de Siniestro`, error);
        throw new Error('Al grabar Documento de Siniestro');
    }
};

export const recuperaDocumentoSin = async (siniestroId) => {
    try {
        const response = await axios.get(`${BASE_URL}/siniestros/documento/${siniestroId}`, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al recuperar Documento de Siniestro`, error);
        throw new Error('Al recuperar Documento de Siniestro');
    }
};

export const obtieneUsuarios = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/usuario/activos`, obtenerConfig());
        //console.log('USUARIOS...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al recuperar Datos de usuario`, error);
        throw new Error('Al recuperar Datos de usuario');
    }
};

export const obtieneUsuariosPuesto = async (puestoId) => {
    try {
        const response = await axios.get(`${BASE_URL}/usuarioPuestoSiniestro/puesto/${puestoId}`, obtenerConfig());
        //console.log('USUARIOS...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al recuperar Usuarios del Puesto`, error);
        throw new Error('Al recuperar Usuarios del Puesto');
    }
};

export const registraUsuariosPuesto = async (objPost, puestoId) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/usuarioPuestoSiniestro/actualizarII/${puestoId}`,
            objPost,
            obtenerConfig()
        );
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al registrar Usuarios del Puesto`, error);
        throw new Error('Al registrar Usuarios del Puesto');
    }
};

export const recuperaPuestosPorUsuario = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/usuarioPuestoSiniestro/usuario`, obtenerConfig());
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener puestos de Usuario`, error);
        throw new Error('Al Obtener puestos de Usuario');
    }
};

// RUTAS DE PUESTO DE SINIESTROS
export const recuperaRutasSiniestro = async (puestoId) => {
    try {
        const response = await axios.get(`${BASE_URL}/puestoSiniestroRuta/puesto/${puestoId}`, obtenerConfig());
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener Rutas del Puesto`, error);
        throw new Error('Al Obtener Rutas del Puesto');
    }
};

export const recuperaRutasDePuestos = async (lstPuestosIds) => {
    //console.log('PARAMETROS DE RUTAS..:',  lstPuestosIds )
    try {
        const response = await axios.post(`${BASE_URL}/puestoSiniestroRuta/rutasPuesto`, lstPuestosIds, obtenerConfig());
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener Rutas del Puesto`, error);
        throw new Error('Al Obtener Rutas del Puesto');
    }
}

export const grabarRutaPuestoSin = async (objPost) => {
    try {
        const response = await axios.post(`${BASE_URL}/puestoSiniestroRuta`, objPost, obtenerConfig());
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener Rutas del Puesto`, error);
        throw new Error('Al Obtener Rutas del Puesto');
    }
};

export const recuperaProyectosDeSiniestro = async (siniestroId) => {
    try {
        const response = await axios.get(`${BASE_URL}/siniestroProyecto/proyectos/${siniestroId}`, obtenerConfig());
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener los Proyectos`, error);
        throw new Error('Al Obtener los Proyectos');
    }
};

export const grabaProyectosBySiniestro = async (siniestroId, listaProy) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/siniestroProyecto/registrar/${siniestroId}`,
            listaProy,
            obtenerConfig()
        );
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener los Proyectos`, error);
        throw new Error('Al Obtener los Proyectos');
    }
};

export const agregaTipoSiniestro = async (objPost) => {
    try {
        const response = await axios.post(`${BASE_URL}/configDet/crearByCab`, objPost, obtenerConfig());
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener los Proyectos`, error);
        throw new Error('Al Obtener los Proyectos');
    }
};

export const modificaTipoSiniestro = async (objPost) => {
    try {
        const response = await axios.put(`${BASE_URL}/configDet`, objPost, obtenerConfig());
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener los Proyectos`, error);
        throw new Error('Al Obtener los Proyectos');
    }
};

export const crearUbicacionSimple = async (objPost, codigoTipo) => {
    try {
        const response = await axios.post(`${BASE_URL}/ubicacionSimple/${codigoTipo}`, objPost, obtenerConfig());
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener los Proyectos`, error);
        throw new Error('Al Obtener los Proyectos');
    }
};

export const modificarUbicacionSimple = async (objPost, codigoTipo) => {
    try {
        const response = await axios.put(`${BASE_URL}/ubicacionSimple/${codigoTipo}`, objPost, obtenerConfig());
        console.log('XXX RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener los Proyectos`, error);
        throw new Error('Al Obtener los Proyectos');
    }
};

export const recuperaSimpleUbicacion = async (codigoTipoUbi) => {
    try {
        const response = await axios.get(`${BASE_URL}/ubicacionSimple/tipoUbicacion/${codigoTipoUbi}`, obtenerConfig());
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener los Proyectos`, error);
        throw new Error('Al Obtener los Proyectos');
    }
};

export const recuperaZonasPorCliente = async (clienteId) => {
    try {
        const response = await axios.get(`${BASE_URL}/clienteSiniestroZona/cliente/${clienteId}`, obtenerConfig());
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener los Proyectos`, error);
        throw new Error('Al Obtener los Proyectos');
    }
};

export const grabaZonasPorCliente = async (clienteId, lstZonasIds) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/clienteSiniestroZona/registrar/${clienteId}`,
            lstZonasIds,
            obtenerConfig()
        );
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener los Proyectos`, error);
        throw new Error('Al Obtener los Proyectos');
    }
};

export const recuperaZonasDelCliente = async (clienteId) => {
    try {
        const response = await axios.get(`${BASE_URL}/clienteSiniestroZona/delCliente/${clienteId}`, obtenerConfig());
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener los Proyectos`, error);
        throw new Error('Al Obtener los Proyectos');
    }
};

export const descargaSiniestroReporte = async (objData) => {
    //console.log('JJJJZ0:', objData)
    try {
        const objHeader = {
            ...obtenerConfig(),
            responseType: 'blob'
        };
        const instante = new Date();
        const cadAhora = instante.toISOString().replace(/\D/g, '').slice(0, 14);

        const response = await axios.post(`${BASE_URL}/reporteSiniestro/reporte`, objData, objHeader);
        //const response = await axios.post(`${BASE_URL}/reporteSiniestro/reporteII`, objData, objHeader);
        const pdfUrl = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = `reporteSiniestro_${cadAhora}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(pdfUrl);
    } catch (error) {
        console.error('Error al descargar PDF. ');
        console.error(`Error al descargar el reporte: ${error.response?.statusText || error.message}`);
    }
};

export const descargaSiniestroReportePorProyecto = async (objData) => {
    try {
        const objHeader = {
            ...obtenerConfig(),
            responseType: 'blob'
        };
        const instante = new Date();
        const cadAhora = instante.toISOString().replace(/\D/g, '').slice(0, 14);

        const response = await axios.post(`${BASE_URL}/reporteSiniestro/reportePorProyecto`, objData, objHeader);
        const zipUrl = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = zipUrl;
        link.download = `Reportes_Por_Proyecto_${cadAhora}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(zipUrl);
    } catch (error) {
        console.error('Error al descargar ZIP de reportes por proyecto.');
        console.error(`Error: ${error.response?.statusText || error.message}`);
        throw error;
    }
};

export const recuperaRutasPorPuesto = async (puestoId) => {
    try {
        const response = await axios.get(`${BASE_URL}/puestoSiniestroRuta/puestoII/${puestoId}`, obtenerConfig());
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener los Rutas del Puesto`, error);
        throw new Error('Al Obtener los Rutas del Puesto');
    }
};

export const grabaRutasPorPuesto = async (puestoId, lstRutasIds) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/puestoSiniestroRuta/registrar/${puestoId}`,
            lstRutasIds,
            obtenerConfig()
        );
        //console.log('RESPUESTA...: ', response.data);
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al Obtener los Proyectos`, error);
        throw new Error('Al Obtener los Proyectos');
    }
};

export const recuperaDatSiniestroPorPuesto = async (objPost) => {
    //console.log ('DOMINGO PARAMETROS....: ', objPost)
    try {
        const response = await axios.post(`${BASE_URL}/siniestros/datosPorPuesto`, objPost, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al consultar Siniestros`, error);
        throw new Error('Al consultar Siniestros');
    }
};

export const recuperaZonasPorPuesto = async (lstPuestos) => {
    //console.log ('PARAMATREO A ENVIAR..:',lstPuestos)
    try {
        const response = await axios.post(`${BASE_URL}/ubicacionSimple/cercasPorPuesto`, lstPuestos, obtenerConfig());
        //console.log ('RESULTADO....: ', response.data)
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al traer Areas del Puesto`, error);
        throw new Error('Al traer Areas del Puesto');
    }
};

export const recuperaRolesByUser = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/usuarioRol/roles`, obtenerConfig());
        //console.log ('RESULTADO....: ', response.data)
        return response.data;
    } catch (error) {
        console.error(`ERROR: Al traer los Roles del Usuario`, error);
        throw new Error('Al traer los Roles del Usuario');
    }
}

